import { useTranslation } from 'react-i18next'
import { FC } from 'react'

import { Link } from '../../components/Link'
import { Routes } from '../../routes'
import { slugify } from '../../utils/helpers'

export const CompanyLink: FC<{
  companyIdentifier?: string
  companyName: string
  companyIdentifierType: string
  domainCode?: string
  previousLocation?: string
}> = ({ companyIdentifier, companyName, domainCode, children, companyIdentifierType, previousLocation }) => {
  const { i18n } = useTranslation()
  if (companyIdentifier && companyName) {
    return (
      <Link
        to={Routes.CompanyDetail}
        params={{ companyIdentifier, slug: slugify(companyName, i18n.language) }}
        data-automation-id="companyLink"
        query={{
          ...(domainCode ? { domainCode } : undefined),
          ...(companyIdentifierType && companyIdentifierType.toLocaleUpperCase() === 'SUPPLIER_ID' // companyname as url param added for skyminder company only
            ? { companyName: encodeURIComponent(companyName) }
            : undefined)
        }}
        state={{ previousLocation: previousLocation }}
      >
        {children}
      </Link>
    )
  }

  return <>{children}</>
}
